import type { ComputedRef, Ref } from 'vue';
import type { UnreadNotification, UnreadNotifications } from '~/interfaces/notifications/main';

// Notifications non lues (badge + liste + marquage « lu ») : logique partagée par la cloche
// desktop (LayoutV2NotifBell) et le shell mobile (MobileApp), qui la réimplémentaient chacun de
// leur côté. `markRead` renvoie un booléen de succès (et logue l'erreur) ; chaque appelant décide
// de son toast — même contrat que le legacy Notifications/Card.vue (PATCH puis re-fetch).
export function useUnreadNotifications (limit: number): {
  data: Ref<UnreadNotifications | null>;
  items: ComputedRef<UnreadNotification[]>;
  unreadCount: ComputedRef<number>;
  fetchNotifs: () => Promise<void>;
  markRead: (id: string | number) => Promise<boolean>;
} {
  const store = useNotificationsStore();
  const data = ref<UnreadNotifications | null>(null);
  const items = computed<UnreadNotification[]>(() => data.value?.data ?? []);
  const unreadCount = computed<number>(() => data.value?.meta?.totalItems ?? items.value.length);

  async function fetchNotifs (): Promise<void> {
    try {
      const response = await store.getNotifications(true, limit);
      data.value = (response as UnreadNotifications | null) ?? null;
    } catch (error) {
      console.error('[useUnreadNotifications] fetch', error);
    }
  }

  async function markRead (id: string | number): Promise<boolean> {
    try {
      const response = await useAuthFetchNext(`notifications/${id}`, { method: 'PATCH', body: { read: true } });
      if (isAPIErrorResponse(response)) { return false; }
      await fetchNotifs();
      return true;
    } catch (error) {
      console.error('[useUnreadNotifications] markRead', error);
      return false;
    }
  }

  return { data, items, unreadCount, fetchNotifs, markRead };
}
